<template>
  <div class="page-recharge-record">
    <div class="time-range-pick-container">
      <div @click="openPickDate(0)">{{startDate | formatDate}}</div>
      <div class="line"></div>
      <div @click="openPickDate(1)">{{endDate | formatDate}}</div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false"
      class="list-container bg-white"
    >
      <div class="list-item" v-for="(item,index) in list" :key="index" @click="gotoDetail(item)">
        <div class="list-item-left-container">
          <div class="order-number">{{item.orderTypeDesc | formatNullValue}} {{orderType == '2' ? item.requestRefundAmount : ''}}</div>
          <div class="content" v-if="item.orderType == 2 && orderType">{{item.createTime | formatNullValue}}</div>
          <div class="content" v-else>{{item.transactionTime | formatNullValue}}</div>
        </div>
        <div class="list-item-right-container" v-if="item.orderType == 2">
            <div style="margin-top:0rem;font-size: 0.32rem;" > 
              <span :style="{color: item.orderStatus == 7 ? '#E64340': '#333'}">{{item | formatOrderStatusDesc}}</span>
              
              <van-icon size="0.3rem" name="arrow" color="#C4C4C4"/>
            </div>
            <div style="color:#14CC80" v-if="item.orderStatus == 6">成功退款：{{item.transactionAmount | formatNullValue}}</div>
        </div>
        <div class="list-item-right-container" v-else>
          <div class="pay-status">
            <span :style="{color: item.orderType == 0 ? '#14CC80': '#999999'}">{{item.orderType == 0 ? '+': ''}}{{item.transactionAmount | formatNullValue}}</span>
            <van-icon size="0.3rem" name="arrow" color="#C4C4C4"/>
          </div>
          <div>余额: {{item.afterBalance | formatNullValue}}</div>
        </div>
      </div>
    </van-list>

    <!--日期选择框-->
    <van-popup v-model="showTimePicker"
               position="bottom">
      <van-datetime-picker
        v-model="dateTimePickDate"
        :title="pickerTitle"
        type="date"
        :style="{ height: '50%' }"
        :min-date="minDate"
        v-on:confirm="onTimePickClick(true)"
        v-on:cancel="onTimePickClick"

      />
    </van-popup>
  </div>
</template>
<script>
import { List, Icon, Popup, DatetimePicker } from 'vant';
import { getTransactionList } from '../../common/api/index';
import { formatDate } from '../../common/old/public/filters';

export default {
  name: 'recharge-record',
  components: {
    [List.name]: List,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageIndex: 1,
      pageSize: 20,
      showTimePicker: false,
      startDate: this.$common.yearFristDate(),
      endDate: new Date(),
      minDate: new Date(2020, 0),
      dateTimePickDate: null,
      chooseDateType: 0, // 0开始， 1结束
      orderType: null,
      pickerTitle:''
    };
  },
  mounted () {
    let time = this.$common.thisTimes('yyyy-MM-dd');
    let year = this.$common.thisTimes('yyyy');
    let start = year - 1;
    time = time.replace(year,start);
    this.startDate = new Date(time);
    this.orderType = this.$route.query.orderType;
    this.setTitle();
    this.onLoad();
  },
  methods: {
    setTitle () {
      if (this.orderType == '0') {
        document.title = '充值记录';
      } else if (this.orderType == '2') {
        document.title = '退款记录';
      } else {
        document.title = '余额明细';
      }
    },
    gotoDetail (item) {
      // if (item.orderType == '0' || item.orderType == '2') {
        this.$router.push({ name: 'record/detail', query: { orderNo: item.orderNo } });
      // } else {
      //   this.$router.push({ name: 'my/order/details', query: { orderNo: item.orderNo } });
      // }
    },
    onLoad () {
      this.requestListData();
    },
    refresh () {
      this.list = [];
      this.pageIndex = 1;
      this.pageSize = 20;
      this.onLoad();
    },
    requestListData () {
      if (this.pageIndex === 1) {
        this.loading = true;
      }
      let json = {
        timeRange: `${formatDate(this.startDate)}~${formatDate(this.endDate)}`,
        orderType: this.$route.query.orderType,
        globalPageIndex: this.pageIndex,
        globalPageSize: this.pageSize
      }
      if(this.$route.query.accountPkId){
        json.accountPkId = this.$route.query.accountPkId
      }
      getTransactionList(json).then((data) => {
        if (!(data.status === this.$config.ajaxStatus)) {
          throw new Error();
        }
        this.loading = false;

        if (this.pageIndex === 1) {
          this.list = [];
        }
        if (data.data) {
          this.list = this.list.concat(data.data);
          // 数据全部加载完成
          this.finished = data.data.length < this.pageSize;
        }
        this.pageIndex++;

      }).catch(error => {
        console.log('request  error:' + error);
        this.loading = false;
        this.finished = true;
      });
    },
    openPickDate (type) {
      this.showTimePicker = true;
      this.chooseDateType = type;
      if (this.chooseDateType === 0) {
        this.pickerTitle = "请选择筛选开始时间";
        this.dateTimePickDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
      } else {
        this.pickerTitle = "请选择筛选结束时间";
        this.dateTimePickDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate());
      }
    },
    onTimePickClick () {
      this.showTimePicker = false;
      if (this.chooseDateType === 0) {
        this.startDate = this.dateTimePickDate;
      } else {
        this.endDate = this.dateTimePickDate;
      }
      if (this.$common.compareDate(this.startDate, this.endDate) > 0) {
        this.$toast('开始时间不能大于结束时间');
        return;
      }
      this.refresh();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/less/old/var.less";

.page-recharge-record {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  .time-range-pick-container {
    display: flex;
    align-items: center;
    font-size: 0.34rem;
    color: #333333;
    background: #F8F4F5;
    box-sizing: border-box;
    margin: 0.24rem 0.5rem;
    line-height: 0.7rem;
    justify-content: center;
    .line {
      width: 0.3rem;
      height: 0.03rem;
      margin: 0 0.2rem;
      background: rgb(156, 153, 154);
    }
  }
}

.list-container {
  flex: 1;
  overflow-y: auto;
  padding: 0 0.25rem;
}

.list-item {
  display: flex;
  padding: 0.2rem 0;
  border-bottom: #dcdcdc 1px solid;
  .list-item-left-container {
    line-height: 0.45rem;
    flex: 1;
    .order-number {
      color: #666666;
      font-size: 0.32rem;
    }
    .content {
      color: #999999;
      font-size: 0.24rem;
      margin-top: 0.1rem;
    }
  }
  .list-item-right-container {
    color: #333333;
    text-align: right;
    .pay-status {
      .flex-align-center();
      justify-content: flex-end;
      font-size: 0.34rem;
      color: #14CC80
    }
    .number {
      font-size: 0.38rem;
      margin-top: 0.1rem;
      span {
        font-size: 0.2rem;
        margin-left: 0.1rem;
      }
    }
    div {
      color: #999999;
      font-size: 0.24rem;
      margin-top: 0.1rem;
    }
  }
}
</style>
